import { useEffect } from "react";
import { fetchApiGet } from "../../Requests";
import { DonateCard } from "../donate/DonateCard";

export function DonateTab({ donates, setDonates, setDialog }) {
  useEffect(() => {
    if (donates !== null) {
      return;
    }

    fetchApiGet("donates").then(([response, json]) => {
      if (response.status === 200) {
        setDonates(json);
      } else {
        setDonates([]);
      }
    });
  }, [donates]);

  return <section className="donate-section">
    <h2>Донатный магазин / IP: <u>ru.kachanovcraft.com</u> и <u>eu.kachanovcraft.com</u></h2>

    <div className="donate-cards">
      {donates === null && <h1>Загружаем...</h1>}
      {donates && donates.map((donate, i) => (
        <DonateCard key={i} donate={donate} setDialog={setDialog} />
      ))}
    </div>
  </section>;
}
